import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { Ionicons } from '@expo/vector-icons';
import Colors from 'src/core/utils/Colors';
import Dimens from 'src/core/utils/Dimens';
import Fonts from 'src/core/utils/Fonts';

interface EmptyStateProps {
	/** Body text shown below the (optional) icon and title. */
	message: string;
	/** Overrides the transparent background; let the parent supply the colour by default. */
	bgColor?: string;
	/** Optional Ionicons glyph shown above the text (e.g. "newspaper-outline"). */
	icon?: React.ComponentProps<typeof Ionicons>['name'];
	/** Colour of the icon; defaults to the neutral grey used for empty states. */
	iconColor?: string;
	/** Optional bold heading shown above the message. */
	title?: string;
}

/**
 * Generic empty-state placeholder for screens/lists that have no data to show.
 */
export default function EmptyState({ message, bgColor, icon, iconColor, title }: EmptyStateProps) {
	return (
		<View style={[styles.container, bgColor ? { backgroundColor: bgColor } : null]}>
			{icon ? <Ionicons color={iconColor ?? Colors.greyIcon} name={icon} size={64} style={styles.icon} /> : null}
			{title ? <Text style={styles.title}>{title}</Text> : null}
			<Text style={styles.message}>{message}</Text>
		</View>
	);
}

const styles = StyleSheet.create({
	container: {
		// Fill the available space and centre the content vertically.
		flex: 1,
		justifyContent: 'center',
		alignItems: 'center',
		paddingHorizontal: Dimens.padding40,
		paddingVertical: Dimens.padding32,
	},
	icon: {
		marginBottom: Dimens.margin16,
	},
	title: {
		fontFamily: Fonts.montserratBold,
		fontSize: Dimens.fontSize20,
		color: Colors.greyTextDark,
		textAlign: 'center',
		marginBottom: Dimens.margin8,
	},
	message: {
		fontFamily: Fonts.montserratRegular,
		fontSize: Dimens.fontSize17,
		lineHeight: Dimens.lineHeight23,
		color: Colors.greyTextDark,
		textAlign: 'center',
	},
});
